import type { Matter } from "@/lib/types";
import { getInsuranceContactConnections } from "@/lib/utils/connections/insurance-contact-connections";
import { getMatterContactConnections } from "@/lib/utils/matters/matter-contact-connection-party-roles";

/** Returns insurances associated with the requested matter party. */
export const getSelectableMatterInsurances = (
  matter: Matter,
  contactConnectionLabel?: "Client" | "Defendant",
  partyContactId?: string,
) => {
  if (!contactConnectionLabel && !partyContactId) {
    return matter.insurances;
  }

  const connections = getMatterContactConnections(matter);
  const partyContactIds = partyContactId
    ? new Set([partyContactId])
    : new Set(
        connections
          .filter((connection) => connection.label === contactConnectionLabel)
          .map((connection) => connection.contactId),
      );

  if (partyContactIds.size === 0) {
    return [];
  }

  return matter.insurances.filter((insurance) =>
    [
      ...getInsuranceContactConnections(insurance, "Insured"),
      ...getInsuranceContactConnections(insurance, "Policy Holder"),
    ].some((connection) => partyContactIds.has(connection.targetObjectId)),
  );
};
